var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('GanttDiagram',{staticClass:"mt-6",attrs:{"events":_vm.dashboard.timeline}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }